import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clientID = localStorage.getItem('client');
        if (!clientID) {
            clientID = sessionStorage.getItem('client');
        }
        let changeReq = req.clone();
        if (clientID) {
            changeReq = req.clone({
                params: req.params.append('client_id', clientID)
            });
        }
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        
        let reqConfig: any = {
            headers: changeReq.headers.set('X-Device-Context', 'asap_authorized_access')
        };

        if (isLocalhost && changeReq.url.includes('https://api.tecnologiaasap.com.br')) {
            reqConfig.url = changeReq.url.replace('https://api.tecnologiaasap.com.br', 'http://127.0.0.1:8000');
        }

        if (!isLocalhost) {
            reqConfig.withCredentials = true;
        }

        changeReq = changeReq.clone(reqConfig);
        return next.handle(changeReq);
    }
}
